import { Component, Mixins, Prop } from 'vue-property-decorator';
import { UtilMixin } from '../../UtilMixin';
@Component({ components: {} })
export default class SuggestionEntryCardHeader extends Mixins(UtilMixin) {
  @Prop() private suggestion!: any;

  get price(): number {
    // return parseFloat(
    // this.findBuyLink(this.suggestion.opdsEntry.links).prices[0].value,
    // );
    return 66.66;
  }

  get count(): number {
    return this.suggestion.status.count;
  }
}
